import { z } from "zod";
import { FactNodeSchema } from "./FactNode";
import {
  NoteFactNodeContentSchema,
  NoteOnPersonFactEdgeMetadataSchema,
} from "./FactNodes/NoteFactNode";
import {
  PersonFactNodeContentSchema,
  PersonKnowsFactEdgeMetadataSchema,
} from "./FactNodes/PersonFactNode";

export const contactMetadata = {
  nodeType: PersonFactNodeContentSchema.shape.nodeType.value,
  nodeVersion: PersonFactNodeContentSchema.shape.version.value,
  edgeType: PersonKnowsFactEdgeMetadataSchema.shape.edgeType.value,
  edgeVersion: PersonKnowsFactEdgeMetadataSchema.shape.version.value,
  edgeRelationship: "contact",
};

export const contactNoteMetadata = {
  nodeType: NoteFactNodeContentSchema.shape.nodeType.value,
  nodeVersion: NoteFactNodeContentSchema.shape.version.value,
  edgeType: NoteOnPersonFactEdgeMetadataSchema.shape.edgeType.value,
  edgeVersion: NoteOnPersonFactEdgeMetadataSchema.shape.version.value,
};

export const ContactSchema = z.object({
  id: FactNodeSchema.shape.id,
  createdAt: z.date(),
  name: PersonFactNodeContentSchema.shape.name,
  alias: PersonFactNodeContentSchema.shape.alias,
  email: z.string().optional(),
  phoneNumber: z.string().optional(),
  website: z.string().url().optional(),
  notes: z.string().optional(),
});

export const FilterContactParamsSchema = z.object({
  skip: z.number().int().optional(),
  take: z.number().int().max(100).optional(),
});

export const CreateContactSchema = ContactSchema.omit({
  id: true,
  createdAt: true,
});

export const UpdateContactSchema = ContactSchema.omit({
  id: true,
  createdAt: true,
});

export type Contact = z.infer<typeof ContactSchema>;
export type FilterContactParams = z.infer<typeof FilterContactParamsSchema>;
export type CreateContact = z.infer<typeof CreateContactSchema>;
export type UpdateContact = z.infer<typeof UpdateContactSchema>;
